import React from "react";

const BulkPipelineModal = ({
  modelOpen4,
  leadPipelineTo,
  leadPipelineOptions,
  setPipelineTo,
  handleAssign4,
  handleCloseModal4,
}) => {
  return (
    <div
      className={`modal ${modelOpen4 ? "show" : ""} bg-black-7`}
      style={{ display: modelOpen4 ? "block" : "none" }}
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div className="modal-content rounded-3">
          <div className="modal-header">
            <h5 className="modal-title">Bulk Pipeline</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleCloseModal4}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body" style={{ width: "100%" }}>
            <div className="row row-sm-1">
              <div className="col-sm-4 form-group">
                <label className="form-label">Assign: </label>
                <select
                  name="leadPipelineTo"
                  value={leadPipelineTo}
                  className="form-control form-select select2"
                  onChange={(e) => setPipelineTo(e.target.value)}
                >
                  <option value={""}>By Lead Pipeline</option>
                  {leadPipelineOptions.map((data, index) => (
                    <option key={index} value={data.name}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-12">
                <button
                  className="btn ripple btn-primary"
                  type="button"
                  onClick={handleAssign4}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkPipelineModal;
